import api from './api.js'
import page from './page.js'

export default {
    api, 
    page
}